import { forwardRef } from 'react';
import { Icon } from '../../components/ui/Icon.jsx';
import styles from './ZoomableImage.module.css';

export const ZoomableImage = forwardRef(function ZoomableImage(
  { src, alt, caption, onOpen, className = '', ...rest },
  ref
) {
  return (
    <button
      type="button"
      ref={ref}
      className={`${styles.zoomable} ${className}`.trim()}
      onClick={onOpen}
      aria-label={`Enlarge image: ${caption ?? alt}`}
      {...rest}
    >
      <img src={src} alt={alt} />
      <span className={styles.hint} aria-hidden="true">
        <Icon name="zoomIn" />
        View
      </span>
    </button>
  );
});
